import type GraphCoordinate from '@/types/api/chart/graph-coordinate.type'

export default class GraphData {
  abscissa?: string
  ordinate?: string
  values: Array<GraphCoordinate> = []
}
